module.exports = __webpack_public_path__ + "images/confluence-crossflow/confluence-logo.11ce2a2b1b30dfbf4bcb.svg";